
import Button from "@/components/base/Button"
import themes from "@/mixins/themes"
import { routeToJob } from "@/helpers/routing"

export default {
    name: "JobAusbildungSummarySection",
    components: {
        Button,
        JobGalleryV3: () => import("@/components/job/jobpage/JobGalleryV3"),
    },
    mixins: [themes],
    props: {
        /** Job object */
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        apprenticeshipMediaList() {
            const mediaList = []
            const blockItems = this.job.content_blocks?.at(0)?.data?.items
            if (blockItems) {
                blockItems.forEach((item) => {
                    const data = item?.data
                    if (data?.media) mediaList.push(...data.media)
                    else {
                        if (data?.images) mediaList.push(...data.images)
                        if (data?.videos) mediaList.push(...data.videos)
                    }
                })
            }
            return mediaList.slice(0, 6).sort(() => 0.5 - Math.random())
        },
        apprenticeshipSummary() {
            return this.job.summary
        },
    },
    methods: {
        routeToJob,
        onShowMore(medium) {
            this.$fullscreenMedia.open(this.apprenticeshipMediaList, {
                initialId: medium.id,
            })
        },
    },
}
